import type { Broker, Instrument } from '@/mocks/compare';

export function spreadFor(inst: Instrument, broker: Broker): number {
  return round(inst.refSpread * broker.spreadFactor, 2);
}

export function spreadCost(inst: Instrument, broker: Broker, lot: number): number {
  return round(inst.spreadCostPerLot * broker.spreadFactor * lot, 2);
}

export function swapFor(inst: Instrument, broker: Broker, dir: 'long' | 'short'): number {
  const base = dir === 'long' ? inst.swapLong : inst.swapShort;
  return round(base * broker.swapFactor, 2);
}

export function swapCost(inst: Instrument, broker: Broker, dir: 'long' | 'short', lot: number, days: number): number {
  return round(swapFor(inst, broker, dir) * lot * days, 2);
}

export function marginFor(inst: Instrument, broker: Broker, lot: number): number {
  const value = inst.contractSize * inst.refPrice * lot;
  return round(value / broker.leverageNum, 2);
}

export function round(value: number, decimals: number): number {
  const f = Math.pow(10, decimals);
  return Math.round(value * f) / f;
}

export function fmtSpread(value: number, unit: string): string {
  return `${value.toFixed(value < 1 ? 2 : 1)} ${unit}`;
}

export function fmtMoney(value: number, decimals = 2): string {
  const sign = value > 0 ? '+' : value < 0 ? '−' : '';
  return `${sign}${Math.abs(value).toFixed(decimals)} USD`;
}